<template>
  <div v-if="element">
    <div style=" color: #666; overflow-x: hidden;">

      <ThemeEditor v-model:dialogVisible="themeDialogVisible"></ThemeEditor>

      <div v-if="elementType === 'element'">
        <Checkbox
            v-model="prototypeTile"
            inputId="prototypeTile"
            binary
            :disabled="isDisabled"
            style="margin-right: 10px;margin-top: 10px;"
        />
        <label for="prototypeTileLabel" :class="{ disabledLabel: isDisabled }" >Prototype Tile</label>
      </div>

      <div v-if="elementType !== 'element'">
        <Checkbox
            v-model="usePrototypeTile"
            inputId="usePrototypeTile"
            :disabled="isDisabled"
            binary
            style="margin-right: 10px;margin-top: 10px;"
        />
        <label for="usePrototypeTileLabel" :class="{ disabledLabel: isDisabled }">Use Prototype Tile Style</label>
        <div v-if="isDisabled" class="disabledLabel"><small>Too many tiles defined as prototypes in your section.</small></div>
      </div>

      <div class="style-section" style="display: flex; align-items: center;">
        <span class="label-long">Background</span>
        <div style="width: 150px; display: inline-block">
          <ColorButton @click="colorPickerVisible.toggle($event)" :color="backgroundColor" style="flex: 3"  />
          <OverlayPanel ref="colorPickerVisible">
            <ColorPicker v-model="backgroundColor"
                         @edit-theme="$refs.colorPickerVisible.toggle(false); themeDialogVisible = true"
            />
          </OverlayPanel>
        </div>
      </div>

      <div class="style-section" style="display: flex; align-items: center;" v-if="element.style.filter">
        <span class="label-long">Image Color</span>
        <div style="width: 150px; display: inline-block">
          <ColorButton @click="colorPickerVisible.toggle($event)" :color="imageColor" style="flex: 3"  />
          <OverlayPanel ref="colorPickerVisible">
            <ColorPicker v-model="imageColor"
                         @edit-theme="$refs.colorPickerVisible.toggle(false); themeDialogVisible = true"
            />
          </OverlayPanel>
        </div>
      </div>

      <div class="style-section">
        <span class="label-long">CSS Class: </span>
        <InputText style="margin-bottom: 15px;" v-model="computedWidgetClass"/>

        <span class="label-long">Apply Rule(s) </span>
        <MultiSelect filter v-model="chosenRules" :options="rules" optionLabel="name" optionValue="id" placeholder="Select a Rule"
                     :maxSelectedLabels="3" :inputStyle="{ width: '120px' }" style="width: 170px; margin-bottom: 15px;" />

        <div v-if="elementType !== 'element'">
          <div class="style-row"><span class="label">Width</span> <InputNumber v-model="containerWidth" showButtons class="dimension-input"/> <Button v-if="containerWidth != null" icon="pi pi-trash" @click="containerWidth = null"></Button></div>
          <div class="style-row"><span class="label">Height</span> <InputNumber v-model="containerHeight" showButtons class="dimension-input"/> <Button v-if="containerHeight != null" icon="pi pi-trash" @click="containerHeight = null"></Button></div>
        </div>

        <div v-if="elementType === 'section'">
          <div class="style-row"><span class="label">Max-Width</span> <InputNumber v-model="maxWidth" showButtons class="dimension-input"/> <Button v-if="maxWidth != null" icon="pi pi-trash" @click="maxWidth = null"></Button></div>
        </div>

        <div v-if="elementType !== 'element'" style="border: solid 1px #dee2e6; border-radius: 7px;z-index: 1;position: relative; margin-top: 10px;">
          <TabView v-model:activeIndex="activeDimensionTab">
            <TabPanel header="All Tiles">
              <div class="style-row"><span class="label">Width</span> <InputNumber v-model="allTilesWidth" showButtons class="dimension-input"/> <Button v-if="allTilesWidth != null" icon="pi pi-trash" @click="allTilesWidth = null"></Button></div>
              <div class="style-row"><span class="label">Height</span> <InputNumber v-model="allTilesHeight" showButtons class="dimension-input"/> <Button v-if="allTilesHeight != null" icon="pi pi-trash" @click="allTilesHeight = null"></Button></div>
            </TabPanel>
          </TabView>
        </div>

        <div v-if="elementType == 'element'" style="border: solid 1px #dee2e6; border-radius: 7px;z-index: 1;position: relative;">
          <TabView v-model:activeIndex="activeDimensionTab">
            <TabPanel header="Tile">
              <div v-if="element.type === 'image'" class="m-0">
                <div class="style-row"><span class="label-long">Width</span> <InputNumber v-model="imageWidth" :placeholder="imageWidthPlaceholder" showButtons class="dimension-input"/> <Button v-if="imageWidth != null" icon="pi pi-trash" @click="imageWidth = null"></Button></div>
                <div class="style-row"><span class="label-long">Height</span> <InputNumber v-model="imageHeight" :placeholder="imageHeightPlaceholder" showButtons class="dimension-input"/> <Button v-if="imageHeight != null" icon="pi pi-trash" @click="imageHeight = null"></Button></div>
                <div class="style-row" style="padding-top: 10px"><span class="label-long">Max Width</span> <InputNumber v-model="imageMaxWidth" showButtons class="dimension-input"/> <Button v-if="imageMaxWidth != null" icon="pi pi-trash" @click="imageMaxWidth = null"></Button></div>
                <div class="style-row"><span class="label-long">Max Height</span> <InputNumber v-model="imageMaxHeight" showButtons class="dimension-input"/> <Button v-if="imageMaxHeight != null" icon="pi pi-trash" @click="imageMaxHeight = null"></Button></div>
                <div v-if="elementType === 'element'" class="style-row">
                  <span class="label">Align</span>
                  <SelectButton v-model="tileAlign" :options="alignFilteredOptions" optionValue="value" dataKey="value" style="display: inline">
                    <template #option="slotProps">
                      <i :class="slotProps.option.icon"></i>
                    </template>
                  </SelectButton>
                </div>
              </div>
              <div v-else class="m-0">
                <div class="style-row"><span class="label">Width</span> <InputNumber v-model="containerWidth" showButtons class="dimension-input"/> <Button v-if="containerWidth != null" icon="pi pi-trash" @click="containerWidth = null"></Button></div>
                <div class="style-row"><span class="label">Height</span> <InputNumber v-model="containerHeight" showButtons class="dimension-input"/> <Button v-if="containerHeight != null" icon="pi pi-trash" @click="containerHeight = null"></Button></div>
                <div v-if="elementType === 'element'" class="style-row">
                  <span class="label">Align</span>
                  <SelectButton v-model="tileAlign" :options="alignFilteredOptions" optionValue="value" dataKey="value" style="display: inline">
                    <template #option="slotProps">
                      <i :class="slotProps.option.icon"></i>
                    </template>
                  </SelectButton>
                </div>
              </div>
            </TabPanel>
            <TabPanel v-if="element.type === 'csv_selector' || (element.type === 'model_data' && element.subType !== 'out_text')" header="Input">
              <div class="m-0">
                <div class="style-row"><span class="label">Width</span> <InputNumber v-model="width" @blur="blurInput()" input-class="preserve-select-input" :min="1" showButtons class="dimension-input"/> <Button input-class="preserve-select-input" v-if="width != null" icon="pi pi-trash" @click="width = null"></Button></div>
                <div class="style-row"><span class="label">Height</span> <InputNumber v-model="height" @blur="blurInput()" input-class="preserve-select-input" :min="1" showButtons class="dimension-input"/> <Button input-class="preserve-select-input" v-if="height != null" icon="pi pi-trash" @click="height = null"></Button></div>
                <div v-if="elementType === 'element'" class="style-row">
                  <span class="label">Align</span>
                  <SelectButton v-model="inputAlign" :options="alignFilteredOptions" optionValue="value" dataKey="value" style="display: inline">
                    <template #option="slotProps">
                      <i :class="slotProps.option.icon"></i>
                    </template>
                  </SelectButton>
                </div>
              </div>
            </TabPanel>
            <TabPanel v-if="element.type === 'model_data'" header="Label">
              <div class="m-0">
                <div class="style-row"><span class="label">Width</span> <InputNumber v-model="secondaryWidth" input-class="preserve-select-text" showButtons :min="1" class="dimension-input"/> <Button v-if="secondaryWidth != null" icon="pi pi-trash" @click="secondaryWidth = null"></Button></div>
                <div class="style-row"><span class="label">Height</span> <InputNumber v-model="secondaryHeight" input-class="preserve-select-text" showButtons :min="1" class="dimension-input"/> <Button v-if="secondaryHeight != null" icon="pi pi-trash" @click="secondaryHeight = null"></Button></div>
                <div v-if="elementType === 'element'" class="style-row">
                  <span class="label">Align</span>
                  <SelectButton v-model="labelAlign" :options="alignFilteredOptions" optionValue="value" dataKey="value" style="display: inline">
                    <template #option="slotProps">
                      <i :class="slotProps.option.icon"></i>
                    </template>
                  </SelectButton>
                </div>
              </div>
            </TabPanel>
            <TabPanel v-if="element.type === 'model_data'" header="Icon">
              <div class="m-0">
                <div class="style-row"><span class="label">Width</span> <InputNumber v-model="iconWidth" input-class="preserve-select-text" showButtons :min="1" class="dimension-input"/> <Button v-if="iconWidth != null" icon="pi pi-trash" @click="iconWidth = 100"></Button></div>
                <div class="style-row"><span class="label">Height</span> <InputNumber v-model="iconHeight" @blur="blurInput()" input-class="preserve-select-input" showButtons  :min="1" class="dimension-input"/> <Button input-class="preserve-select-input" v-if="iconHeight != null" icon="pi pi-trash" @click="iconHeight = 100"></Button></div>
                <div class="style-row"><span class="label-x-long">Lock Aspect Ratio</span><Checkbox v-model="aspectRatio" inputId="aspectRatio" binary /></div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>

      <div class="style-section">
        <div v-if="elementType !== 'element'" class="style-row">
          <span class="label">Align</span>
          <SelectButton v-model="sectionAlign" :options="alignFilteredOptions" optionValue="value" dataKey="value" style="display: inline">
            <template #option="slotProps">
              <i :class="slotProps.option.icon"></i>
            </template>
          </SelectButton>
        </div>
        <div class="style-row"><span class="label">Vertical</span>
          <SelectButton v-model="valign" :options="valignOptions" optionValue="value" dataKey="value" style="display: inline">
            <template #option="slotProps">
              <component :is="slotProps.option.icon" />
            </template>
          </SelectButton>
        </div>
        <div v-if="elementType == 'element'" class="style-row" style="margin-top: 10px" >
          <span class="label">Line</span>
          <InputNumber v-model="lineHeight" :step="0.1" :min="0.1" showButtons class="font-incrementer"/>
          <Button v-if="lineHeight != null" icon="pi pi-trash" @click="lineHeight = null"></Button>
        </div>
      </div>

      <border-style-editor label="Border" attribute="border"  :element-type="elementType" :mappings="{ prefix: 'border', all: 'borderWidth' }" :color="true"></border-style-editor>
      <div style="margin: 2px 0 10px 5px"><span class="label-long">Border Radius</span> <InputNumber class="dimension-input" v-model="borderRadius" showButtons /> <Button v-if="borderRadius != null" icon="pi pi-trash" @click="borderRadius = null"></Button></div>
      <border-style-editor label="Padding" attribute="padding" :element-type="elementType" :mappings="{ prefix: 'padding' }"></border-style-editor>
      <border-style-editor label="Margin" attribute="margin" :element-type="elementType" :mappings="{ prefix: 'margin' }"></border-style-editor>

    </div>
  </div>
</template>
<script setup lang="ts">
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import {computed, defineProps, reactive, ref, watch} from 'vue'
import BorderStyleEditor from "./BorderStyleEditor.vue"
import InputNumber from "primevue/inputnumber"
import Button from "primevue/button"
import SelectButton from "primevue/selectbutton"
import {storeToRefs} from "pinia";
import {useMainStore, useSlidesStore, useWidgetStore} from "@/store";
import 'primeicons/primeicons.css'
import ColorPicker from "@/components/ColorPicker/index.vue";
import ColorButton from "@/views/Editor/Toolbar/common/ColorButton.vue";
import emitter, {EmitterEvents} from "@/utils/emitter";
import {PPTDragDropElement, PPTSlideLayoutElement} from "@/types/slides";
import {useMicroservice} from "@/hooks";
import ThemeEditor from "@/components/ThemeEditor.vue";
import _ from 'lodash'
import tinycolor from "tinycolor2";
import {hexToCSSFilter} from "hex-to-css-filter";

const widgetStore = useWidgetStore()
const slidesStore = useSlidesStore()
const {rules} = storeToRefs(useSlidesStore())
const { selectedWidget, textSelected, alignment, inputSelected, selectedSectionId,
  selectedSectionRowId, selectedSubsectionId, selectedSubsectionRowId, selectedDragDropId, sectionSelected, subsectionSelected } = storeToRefs(widgetStore)
const { selectedTableCells: selectedCells, themeDialogVisible } = storeToRefs(useMainStore())
const api = useMicroservice()
const props = defineProps({
  elementType: {
    type: String,
    required: true
  },
  activeTab: {
    type: String,
    default: null
  }
})

const prototypeTile = computed({
  get: () => element.value?.prototypeTile,
  set: val => {
    element.value.prototypeTile = val
    if (val) {
      const subsection = findSubsection.value
      const section = findSection.value

      if (subsection.usePrototypeTile) subsection.prototypeTileStyle = element.value.style
      if (section.usePrototypeTile) section.prototypeTileStyle = element.value.style
    }
  }
})

const usePrototypeTile = computed({
  get: () => element.value?.usePrototypeTile,
  set: val => {
    const isSection = props.elementType === "section"
    const target = isSection ? findSection.value : findSubsection.value
    const getPrototypeStyle = isSection ? findPrototypeWidgetStyleForSection.value : findPrototypeWidgetStyleForSubsection.value

    if (!val) {
      if (target.prototypeTileStyle) {
        delete target.prototypeTileStyle
      }
    } else {
      target.prototypeTileStyle = getPrototypeStyle
    }

    element.value.usePrototypeTile = val
  }
})

const chosenRules = computed({
  get: () => element.value?.ruleIds,
  set: val => {
    element.value.ruleIds = val
  }
})

const selectedCell = computed(() => {
  if (selectedCells.value.length) {
    const selectedCell = selectedCells.value[0]
    const rowIndex = +selectedCell.split('_')[0]
    const colIndex = +selectedCell.split('_')[1]
    if (selectedWidget.value?.data && selectedWidget.value?.data.length > rowIndex &&
        selectedWidget.value?.data[rowIndex].length > colIndex) {
      return selectedWidget.value?.data[rowIndex][colIndex]
    }
  }
  return null
})

const activeDimensionTab = ref(0)
watch(inputSelected, (newValue) => {
  if (newValue) activeDimensionTab.value = 1
  else activeDimensionTab.value = 0
});

const lineHeight = computed({
  get() {
    return selectedWidget.value?.style?.lineHeight
  },
  set(val) {
    if (selectedWidget.value) {
      // default to 1.5 when using spinner
      if (!selectedWidget.value.style.lineHeight && val == 0.1) {
        val = 1.5
      }
      selectedWidget.value.style.lineHeight = val
    }
  }
})

const subsections = reactive({});
const sections = reactive({});

const getSelectedDragDrop = () => {
  if (selectedDragDropId.value) {
    for (const dragdrop of slidesStore.getElementsByType('dragdrop')) {
      if (dragdrop.id === selectedDragDropId.value) {
        return <PPTDragDropElement>dragdrop
      }
    }
  }

  return <PPTDragDropElement>slidesStore.getElementsByType('dragdrop')[0]
}

const findSubsection = computed(() => {
  const dragDropElement = getSelectedDragDrop()
  const row = dragDropElement.layout.find((row) => row.id === selectedSubsectionRowId.value)
  if (row) {
    return row.children.find((col) => col.id === selectedSubsectionId.value)
  }
})


const getSlideLayoutElement = () => {
  return slidesStore
      .getElementsByType('slidelayout')
      .find((element) =>
          element.layout.children.some((row) =>
              row.children.some((section) => section.id === selectedSectionId.value)
          )
      )
}

const findSection = computed(() => {
  const slideLayoutElement: PPTSlideLayoutElement = <PPTSlideLayoutElement>getSlideLayoutElement()
  if (slideLayoutElement) {
    const row = slideLayoutElement.layout.children.find((row) => row.id == selectedSectionRowId.value)
    if (row) {
      return row.children.find((col) => col.id === selectedSectionId.value)
    }
  }
  return {}
})

const findPrototypeWidget = (isSection = true, returnStyle = false) => {
  const dragDropElement = getSelectedDragDrop()
  if (!dragDropElement?.widgets) return returnStyle ? undefined : []
  const getSubsectionWidgets = dragDropElement.widgets.find(item => item.parent === `${dragDropElement.id}-${selectedSubsectionId.value}`)

  const widgets = isSection ? dragDropElement.widgets : getSubsectionWidgets?.children
  if (!widgets) return returnStyle ? undefined : []

  const results = []
  for (const parentOrChild of widgets) {
    const children = isSection ? parentOrChild.children : [parentOrChild]
    for (const child of children) {
      if (child.prototypeTile) {
        if (returnStyle) return child.style
        results.push(child.id)
      }
    }
  }

  return returnStyle ? undefined : results
}

const findPrototypeWidgetStyleForSection = computed(() =>
    findPrototypeWidget(true, true)
)

const findPrototypeWidgetStyleForSubsection = computed(() =>
    findPrototypeWidget(false, true)
)

const findPrototypeWidgetInSection = computed(() =>
   findPrototypeWidget(true, false)
)

const findPrototypeWidgetInSubsection = computed(() =>
    findPrototypeWidget(false, false)
)

const isDisabled = computed(() => {
  const section = findSection.value
  if (props.elementType === 'section' && findPrototypeWidgetInSection.value.length > 1) {
    return true
  } else if (props.elementType === 'element' && section.usePrototypeTile && findPrototypeWidgetInSection.value.length > 1 && !element.value.prototypeTile) {
    return true
  }
  else {
    return props.elementType === 'element' && findPrototypeWidgetInSubsection.value.length > 0 && !element.value.prototypeTile;
  }
})

const element = computed(() => {
  if (props.elementType === 'element') {
    activeDimensionTab.value = 0
    return selectedWidget.value
  }

  if (props.elementType === 'subsection') {
    if (selectedSubsectionId.value) {
      const subsection = findSubsection.value

      if (subsection) {
        // Ensure the subsection is stored reactively
        if (!subsections[selectedSubsectionId.value]) {
          subsections[selectedSubsectionId.value] = reactive({
            ...subsection,
            type: 'subsection',
            style: subsection.style || {},
          });
        }

        return findSubsection.value
      }
    }
  }

  if (props.elementType === 'section') {
    if (selectedSectionId.value) {

      const section = findSection.value

      if (section) {
        // Ensure the section is stored reactively
        if (!sections[selectedSectionId.value]) {
          sections[selectedSectionId.value] = reactive({
            ...section,
            type: 'section',
            style: section.style || {},
          });
        }

        return findSection.value;
      }
    }
  }

  return null
}) as any | null

const aspectRatio = computed({
  get() {
    return element.value?.style.lockAspectRatio ?? true;
  },
  set(value) {
    element.value.style.lockAspectRatio = value;
  }
});

const createDimension = (key, defaultValue?) => computed({
  get: () => {
    return element.value?.style[key] ?? defaultValue;
  },
  set: val => {
    // default value to 50 if using arrows
    if (!element.value.style[key] && val === 1) {
      val = 50
    }

    element.value.style[key] = val

  }
})

const imageWidthPlaceholder = computed(() => element.value?.style?.imageRatio && element.value?.style?.imageHeight ? Math.round(element.value?.style?.imageHeight * element.value?.style?.imageRatio) : element.value?.style?.imageSrcWidth)
const imageHeightPlaceholder = computed(() => element.value?.style?.imageRatio && element.value?.style?.imageWidth ? Math.round(element.value?.style?.imageWidth / element.value?.style?.imageRatio) : element.value?.style?.imageSrcHeight)

const containerWidth = createDimension('containerWidth')
const containerHeight = createDimension('containerHeight')
const maxWidth = createDimension('maxWidth')

const secondaryWidth = createDimension('secondaryWidth')
const secondaryHeight = createDimension('secondaryHeight')
const iconWidth = createDimension('iconWidth', 100)
const iconHeight = createDimension('iconHeight', 100)
const imageWidth = createDimension('imageWidth', element.value?.style?.imageWidth)
const imageHeight = createDimension('imageHeight', element.value?.style?.imageHeight)
const imageMaxWidth = createDimension('imageMaxWidth', element.value?.style?.imageMaxWidth)
const imageMaxHeight = createDimension('imageMaxHeight', element.value?.style?.imageMaxHeight)

const allTilesWidth = createDimension('allTilesWidth')
const allTilesHeight = createDimension('allTilesHeight')

const width = createDimension('width')
const height = createDimension('height')

const sectionAlign = computed({
  get: () => {
    return element.value?.style['align'] ?? 'center';
  },
  set: val => {
    if (val === 'justify') {
      element.value.style['justifyContent'] = 'space-between'
    } else {
      element.value.style['justifyContent'] = ''
      element.value.style && (element.value.style['align'] = val)
    }
  }
})



const labelAlign = computed({
  get: () => {
      return alignment.value
  },
  set: val => {
      element.value.style['justifyContent'] = ''
      emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, {action: {command: 'align', value: val}})
      alignment.value = val
  }
})

const inputAlign = computed({
  get: () => {
  if (element.value?.type === 'reg_text') {
      return alignment.value
    } else {
      return element.value?.style['inputAlign'] ?? 'center';
    }
  },
  set: val => {
    if (element.value.type === 'reg_text') {
      element.value.style['justifyContent'] = ''
      emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, {action: {command: 'align', value: val}})
      alignment.value = val
    } else if (val === 'justify') {
      element.value.style['justifyContent'] = 'space-between'
    } else {
      element.value.style['justifyContent'] = ''
      element.value.style && (element.value.style['inputAlign'] = val)
    }
  }
})

const tileAlign = computed({
  get: () => {
    if (element.value?.type === 'table') {
      return selectedCell.value?.align ?? 'left'
    } else if(element.value?.type === 'reg_text') {
      return alignment.value
    } else {
      return element.value?.style['align'] ?? 'center';
    }
  },
  set: val => {
    if (element.value) {
      if (element.value.type === 'table') {
        selectedCell.value && (selectedCell.value.align = val)
      } else if (val === 'justify') {
        element.value.style['justifyContent'] = 'space-between'
        element.value.style && (element.value.style['align'] = val)
      } else {
        element.value.style['justifyContent'] = val
        element.value.style && (element.value.style['align'] = val)
        emitter.emit(EmitterEvents.RICH_TEXT_COMMAND, {action: {command: 'align', value: val}})
        alignment.value = val
      }
    }
  }
})

const valign = computed({
  get: () => {
    if (element.value?.type === 'table') {
      return selectedCell.value?.valign ?? 'center'
    }
    else {
      if (!element.value?.style) {
        return ''
      }
      return element.value?.style['valign'] ?? 'center';
    }
  },
  set: val => {
    if (element.value?.type === 'table') {
      selectedCell.value && (selectedCell.value.valign = val)
    }
    else {
      element.value.style && (element.value.style['valign'] = val)
    }
  }
})

const alignFilteredOptions = computed(() => {
  if (element.value?.subType !== 'input_number' && element.value?.subType !== 'choice' && element.value?.subType !== 'model_text') {
    return alignOptions
  }
  return alignOptions
})

const alignOptions = [
  { icon: 'pi pi-align-left', value: 'left' },
  { icon: 'pi pi-align-center', value: 'center' },
  { icon: 'pi pi-align-right', value: 'right' },
  { icon: 'pi pi-align-justify', value: 'justify' }
]

const valignOptions = ref([
  { label: 'Top', value: 'start', icon: 'IconAlignTop' },
  { label: 'Center', value: 'center', icon: 'IconAlignVertically' },
  { label: 'Bottom', value: 'end', icon: 'IconAlignBottom' },
])

const colorPickerVisible = ref()
const backgroundColor = computed({
  get: () => element.value?.style?.backgroundColor ?? 'transparent',
  set: val => element.value && (element.value.style.backgroundColor = val)
})

const imageColor = computed({
  get: () => {
    return element.value.style.hex
  },
  set: val => {
    const realHex = tinycolor(val).toHexString()
    const cssFilter = hexToCSSFilter(realHex)
    element.value.style.filter = cssFilter.filter.replace(/;$/, '')
    element.value.style.hex = val
  }
})

const borderRadius = computed({
  get: () => element.value?.style?.borderRadius,
  set: val => {
    element.value && (element.value.style.borderRadius = val)
  }
})

const updateNumberFormat = computed({
  get: () => element.value?.compact ?? false,
  set: val => {
    element.value.compact = val
  }
})



const computedWidgetClass = computed({
  get: () => element.value?.widgetClass,
  set: val => {
    const isValid = isValidCssSelector(val)

    if (isValid) {

      console.log('saving', val, element.value)
      element.value.widgetClass = val
      element.value && (element.value.style.widgetClass = val)
    }
  }
})

const isValidCssSelector = (selector) => {
  if (!selector.trim()) {
    return true;
  }

  const cssSelectorRegex = /^[.#]?[\w-]+(?:\[[^\]]*\]|\.[^.]+)*$/;

  return cssSelectorRegex.test(selector);


}


const blurInput = () => {
  setTimeout(() => {
    if(!document.activeElement?.classList.contains('preserve-select-input')) {
      inputSelected.value = false
    }
  }, 100)
}

const debouncedSave = _.debounce(async () => {
  await api.savePresentation();
}, 10000);

watch([
  borderRadius,
  updateNumberFormat,
  backgroundColor,
  valign,
  tileAlign,
  labelAlign,
  inputAlign,
  containerWidth,
  containerHeight,
  width,
  height,
  iconWidth,
  iconHeight,
  secondaryWidth,
  maxWidth
], () => {
  if (props.elementType == 'element' && element.value.prototypeTile) {
    const subsection = findSubsection.value
    const section = findSection.value
    if (subsection.usePrototypeTile) subsection.prototypeTileStyle = element.value.style
    if (section.usePrototypeTile) section.prototypeTileStyle = element.value.style
  }
  debouncedSave()
})

watch(() => props.activeTab, (newValue) => {
  const stateMap = {
    Section: () => {
      subsectionSelected.value = false
      sectionSelected.value = true
    },
    Subsection: () => {
      subsectionSelected.value = true
      sectionSelected.value = false
    },
    Tile: () => {
      subsectionSelected.value = false
      sectionSelected.value = false
    },
  }

  if (stateMap[newValue]) {
    stateMap[newValue]()
  }
})


</script>
<style scoped>
.dimension-input :deep(.p-inputtext) { width: 110px; }

span.label { display: inline-block; width: 60px }
span.label-long { display: inline-block; width: 100px }
span.label-x-long { display: inline-block; width: 120px }

.style-section { margin-top: 20px; margin-bottom: 20px;}
.style-row { margin-top: 5px; width: 350px; align-items: center; display: flex  }

:deep(.p-highlight span) { z-index: 100; }
:deep(.p-selectbutton .p-button::before) {
  transition: none !important;
}

:deep(.p-tag) { margin-left: 5px;}
:deep(.p-tag-value) { line-height: 1}
:deep(.chk-box) {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

:deep(.chk-box label) {
  margin-left: 5px;
}

:deep(.p-button){
  background: #fff;
  border: 1px solid #ccc;
  color: black;
}

.dimension-input :deep(.p-inputtext) {
  width: 50px;
}

.smaller-switch {
  transform: scale(0.6);
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
}


.disabledLabel {
  color: gray;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
